import { render } from "./OrdersPage.vue?vue&type=template&id=f96eb704&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"

import "./OrdersPage.vue?vue&type=style&index=0&id=f96eb704&lang=css"
import "./OrdersPage.vue?vue&type=style&index=1&id=f96eb704&lang=css"
import "./OrdersPage.vue?vue&type=style&index=2&id=f96eb704&lang=css"
import "./OrdersPage.vue?vue&type=style&index=3&id=f96eb704&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96eb704"]])

export default __exports__